import { Accordion } from './accordion'
import { AccordionCheckbox } from './accordion-checkbox'

export { Accordion, AccordionCheckbox }
export default Accordion
